import React, { useState } from "react";
import { Jumbotron, Form } from "react-bootstrap";
export default function Step1() {
  const { biz_title, biz_type } = this.state;

  return (
    <>
      <h4 className="text-muted font-weight-light">
        Step 1: Tell us about your brand
      </h4>

      <Form className="pt-3">
        <Form.Group controlId="formGroupEmail">
          <Form.Label>Brand name</Form.Label>
          <Form.Control
            type="text"
            value={biz_title}
            onChange={this.handleChange}
            placeholder=""
            name="biz_title"
          />
        </Form.Group>
        <Form.Group controlId="gsForm.ControlSelect1">
          <Form.Label>Brand type</Form.Label>
          <Form.Control
            name="biz_type"
            as="select"
            value={biz_type}
            onChange={this.handleChange}
          >
            <option value=""></option>
            <option value="food">Food</option>
            <option value="hospitality">Hospitality</option>
            <option value="childcare_service">Childcare service</option>
          </Form.Control>
        </Form.Group>
      </Form>
    </>
  );
}
